import { render, staticRenderFns } from "./BannerCompletedAction.vue?vue&type=template&id=cd31a47c&"
import script from "./BannerCompletedAction.vue?vue&type=script&lang=js&"
export * from "./BannerCompletedAction.vue?vue&type=script&lang=js&"
import style0 from "./BannerCompletedAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports